module.exports = __webpack_public_path__ + "assets/e8b2a9d190871565bd0eaa20e915dbd7.png";